module.exports = __webpack_public_path__ + "img/Competitionleft1.147ca55b.png";